module.exports = __webpack_public_path__ + "img/login_logo.8825d621.png";